declare global {
  interface Window {
    env: { [key: string]: string }
  }
}

export const env = (variable: string): string | undefined =>
  process.env.NODE_ENV === 'production' ? window.env[variable] : process.env[variable]
